import React, { useState, useCallback } from 'react';

export function useCollapsibleMenuHandlers() {
	const [menuExpanded, setMenuExpanded] = useState(false);

	const collapseMenu = useCallback(() => {
		setMenuExpanded(false);
	}, []);

	const toggleMenu = useCallback(() => {
		setMenuExpanded((prev) => !prev);
	}, []);

	const onClickOutside = useCallback(
		(ref) => (evt) => {
			if (!ref || !ref.contains(evt.target)) {
				collapseMenu();
			}
		},
		[collapseMenu],
	);

	return { menuExpanded, collapseMenu, toggleMenu, onClickOutside };
}

function withCollapsibleMenuHandlers(WrappedComponent) {
	const WithCollapsibleMenuHandlers = (props) => {
		const hookResult = useCollapsibleMenuHandlers();
		return (
			<WrappedComponent
				{...props}
				{...hookResult}
			/>
		);
	};
	WithCollapsibleMenuHandlers.displayName = `withCollapsibleMenuHandlers(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WithCollapsibleMenuHandlers;
}

export default withCollapsibleMenuHandlers;
